import { observable, autorun } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
import api from "./Ticket.API";
import { TicketStatus, TicketTypes, TicketFields } from "./Ticket.Constant";

class TicketStore {
  @observable listTicket = [];

  getList = async (page, status) => {
    const res = await api.adminList({
      [TicketFields.status]: status || TicketStatus.SUBJECT_WAITING_FOR_RESPONSE,
      [TicketFields.type]: TicketTypes.CLAIM_CONTRACTOR,
      page: page || 1,
    });
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    const json = await res.json();
    this.listTicket = VarHelper.cloneDeep(json.data) || [];
  };

  create = async (data) => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  update = async (data) => {
    const res = await api.update(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  detail = async ({id}) => {
    const res = await api.detail({id});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  updateClaim = async (data) => {
    const res = await api.updateClaim(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };
}

const ticketStore = new TicketStore();
export default ticketStore;



// WEBPACK FOOTER //
// ./src/services/ticket/Ticket.Store.js